export default __webpack_public_path__ + "static/media/instagram.57171697.svg";